/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { GetMaintenanceScheduleQueryResponse, GetMaintenanceSchedulePathParams, GetMaintenanceScheduleQueryParams, GetMaintenanceSchedule400, GetMaintenanceSchedule401, GetMaintenanceSchedule403, GetMaintenanceSchedule404, GetMaintenanceSchedule409, GetMaintenanceSchedule500 } from "../../types/equipmentController/GetMaintenanceSchedule.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getMaintenanceSchedule } from "../../client/equipmentController/getMaintenanceSchedule.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getMaintenanceScheduleQueryKey = (organizationId: GetMaintenanceSchedulePathParams["organizationId"] | undefined, params?: GetMaintenanceScheduleQueryParams) => [{ url: '/api/organizations/:organizationId/equipment/schedule', params: {organizationId:organizationId} }, ...(params ? [params] : [])] as const

export type GetMaintenanceScheduleQueryKey = ReturnType<typeof getMaintenanceScheduleQueryKey>

export function getMaintenanceScheduleQueryOptions(organizationId: GetMaintenanceSchedulePathParams["organizationId"] | undefined, params?: GetMaintenanceScheduleQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getMaintenanceScheduleQueryKey(organizationId, params)
        return queryOptions<GetMaintenanceScheduleQueryResponse, ResponseErrorConfig<GetMaintenanceSchedule400 | GetMaintenanceSchedule401 | GetMaintenanceSchedule403 | GetMaintenanceSchedule404 | GetMaintenanceSchedule409 | GetMaintenanceSchedule500>, GetMaintenanceScheduleQueryResponse, typeof queryKey>({
         enabled: !!(organizationId),
         queryKey,
         queryFn: async ({ signal }) => {
            return getMaintenanceSchedule(organizationId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get maintenance schedule
 * {@link /api/organizations/:organizationId/equipment/schedule}
 */
export function useGetMaintenanceSchedule<TData = GetMaintenanceScheduleQueryResponse, TQueryData = GetMaintenanceScheduleQueryResponse, TQueryKey extends QueryKey = GetMaintenanceScheduleQueryKey>(organizationId: GetMaintenanceSchedulePathParams["organizationId"] | undefined, params?: GetMaintenanceScheduleQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<GetMaintenanceScheduleQueryResponse, ResponseErrorConfig<GetMaintenanceSchedule400 | GetMaintenanceSchedule401 | GetMaintenanceSchedule403 | GetMaintenanceSchedule404 | GetMaintenanceSchedule409 | GetMaintenanceSchedule500>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? getMaintenanceScheduleQueryKey(organizationId, params)
         

         const query = useQuery({
          ...getMaintenanceScheduleQueryOptions(organizationId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetMaintenanceSchedule400 | GetMaintenanceSchedule401 | GetMaintenanceSchedule403 | GetMaintenanceSchedule404 | GetMaintenanceSchedule409 | GetMaintenanceSchedule500>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}